package com.evoapps.evoshift.domain.usecase.settings

import com.evoapps.evoshift.domain.model.WorkplaceSettings
import com.evoapps.evoshift.domain.repository.WorkplaceRepository

class UpdateWorkplaceSettingsUseCase(
    private val workplaceRepository: WorkplaceRepository
) {
    suspend operator fun invoke(workplaceId: String, newSettings: WorkplaceSettings): Result<Unit> {
        return try {
            workplaceRepository.updateSettings(workplaceId, newSettings).getOrThrow()
            Result.success(Unit)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}